export const stripeKey =
  "pk_test_51JcrfTSB2B44O7xahmcL8a0jFI0VGxz5LBhMeBQtRradUBivA23YhMi3zkUjCGbUpmp3ih19eahYRbY5800ucH0H00re9BmCPj";
